import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getPerformance, trace } from "firebase/performance";
import { getStorage } from "firebase/storage";
import "first-input-delay";

// Firebase client config. These values are safe to expose in the browser —
// access is controlled by Firebase Security Rules. Fallbacks point at the
// shared dev project (wethecity-dev) so local dev works out of the box.
// Override via .env.local for a different environment.
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? "AIzaSyC__6pg458wH3M6jqYbJUNuHhO_z_I6r0U",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? "wethecity-dev.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? "wethecity-dev",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? "wethecity-dev.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? "475570137318",
  appId: import.meta.env.VITE_CLIENT_APP_ID ?? "1:475570137318:web:d1e55276bac90437d47327",
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
let firebasePerformance: ReturnType<typeof getPerformance> | null = null;

if (typeof window !== "undefined") {
  // Google Analytics is handled entirely by the gtag.js snippet in index.html
  // (single GA4 property G-ZLNEV7BV28, gated to the murmurations.ar host).
  // Firebase Analytics is intentionally NOT initialized here — a second stream
  // would split events across two GA4 properties. Performance Monitoring below
  // is independent of Analytics.
  try {
    firebasePerformance = getPerformance(app);
    const initialDataDisplayTrace = trace(firebasePerformance, "initial_data_display");
    initialDataDisplayTrace.start();
    window.setTimeout(() => {
      initialDataDisplayTrace.stop();
    }, 100);
  } catch (error) {
    console.warn("[firebase] Performance Monitoring is unavailable in this environment.", error);
  }
}

export function startCustomTrace(traceName: string): ReturnType<typeof trace> | null {
  if (!firebasePerformance) {
    return null;
  }

  try {
    const customTrace = trace(firebasePerformance, traceName);
    customTrace.start();
    return customTrace;
  } catch (error) {
    console.warn("[firebase] Failed to start Performance Monitoring trace.", error);
    return null;
  }
}

export const auth = getAuth(app);
export const storage = getStorage(app);
